import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { createMeetingRecording, createMeetingRecordingFromSignedId } from "./api"

export function useCreateMeetingRecording() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ meetingId, file }: { meetingId: string; file: File }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return createMeetingRecording(context, meetingId, file, getContext)
    },
    onSuccess: () => {
      // Invalidate the meeting data to refresh the recording status
      queryClient.invalidateQueries({ queryKey: ["meeting"] })
      queryClient.invalidateQueries({ queryKey: ["meetings"] })
    },
  })
}

export function useCreateMeetingRecordingFromSignedId() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ meetingId, signedId }: { meetingId: string; signedId: string }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return createMeetingRecordingFromSignedId(context, meetingId, signedId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meeting"] })
      queryClient.invalidateQueries({ queryKey: ["meetings"] })
    },
  })
}
